import { render, staticRenderFns } from "./SpaceDetailsPage.vue?vue&type=template&id=51d3ccf6"
import script from "./SpaceDetailsPage.vue?vue&type=script&lang=ts"
export * from "./SpaceDetailsPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports